import { EnumSchema } from '../metadata-schema';

export const CohortrendementTotDoublure: EnumSchema = {
	"type": "string",
	"title": "CohortrendementTotDoublure",
	"enum": [
		"Zonder vertraging",
		"Zonder vertraging (prognose)",
		"Gedoubleerd",
		"Gedoubleerd (prognose)"
	]
};
